import { inject } from 'mobx-react'
import React from 'react'
import { IStores } from 'src/Stores'
import { InvoiceInboxItem } from '../viewModels/workflow/InvoiceInboxItem'
import WorkflowInbox from './WorkflowInbox'
import { Box, Button, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { Receipt, Warning } from '@mui/icons-material'
import {
  getInvoiceInboxItem,
  getDefaultInvoiceInboxItem,
} from 'src/services/WorkflowService'
import { InboxItemType } from 'src/utils/InboxItemType'
import createDocumentUrl from 'src/utils/createDocumentUrl'
import { ICMS1500 } from 'src/Definitions'

class InvoiceParams {
  quoteId: string | undefined
}

class matchParams {
  params: InvoiceParams | undefined
  path: string | undefined
  url: string | undefined
}

interface IInvoiceInboxProps {
  invoiceId?: string
  inboxId?: string
  isLoading?: boolean
  rerouteToPath?: (path: string) => void
  setReturn?: () => void
  closeTab?: () => void
  setUpdateParentAfterStaticAction?: (parentfunction?: () => void) => void
}

class InvoiceInbox extends React.Component<IInvoiceInboxProps> {
  public state = {
    headerInfo: undefined as unknown as InvoiceInboxItem,
    isLoading: true,
    associatedQuoteId: '',
    invoiceData: '',
  }

  public async componentDidMount(): Promise<void> {
    if (this.props.invoiceId && this.props.inboxId) {
      await getInvoiceInboxItem(this.props.invoiceId, this.props.inboxId)
        .then(async (response: InvoiceInboxItem) => {
          var url = response.associatedInvoicePdfData
            ? createDocumentUrl(
                response.associatedInvoicePdfData.toString(),
                'application/pdf'
              )
            : ''
          this.setState({
            invoiceData: url,
            headerInfo: response,
            isLoading: false,
          })
        })
        .catch(() => {
          this.setState({ isLoading: false })
        })
    } else if (this.props.invoiceId) {
      await getDefaultInvoiceInboxItem(this.props.invoiceId)
        .then(async (response: InvoiceInboxItem) => {
          var url = response.associatedInvoicePdfData
            ? createDocumentUrl(
                response.associatedInvoicePdfData.toString(),
                'application/pdf'
              )
            : ''
          this.setState({
            invoiceData: url,
            headerInfo: response,
            associatedQuoteId: response.associatedQuoteId,
            isLoading: false,
          })
        })
        .catch(() => {
          this.setState({ isLoading: false })
        })
    }
  }
  public renderPdf() {
    return (
      <div style={{ width: '100%' }}>
        <Box display="flex" p={1} style={{ padding: 0 }}>
          <Box p={1} flexGrow={1}>
            {this.state.headerInfo.printAlert && (
              <Typography variant="h5" color="error">
                <Warning color="error"></Warning>&nbsp;&nbsp;
                {this.state.headerInfo.printAlert}
              </Typography>
            )}
          </Box>
          {/*<Box p={1}>*/}
          {/*  <Button*/}
          {/*    variant="contained"*/}
          {/*    color="primary"*/}
          {/*    onClick={() =>*/}
          {/*      window.open(*/}
          {/*        `/workflow/invoice/${this.state.headerInfo.associatedItemId}/default-inbox`*/}
          {/*      )*/}
          {/*    }*/}
          {/*  >*/}
          {/*    View Original Claim*/}
          {/*  </Button>*/}
          {/*</Box>*/}
          <Box p={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                window.open(this.state.invoiceData, 'new', 'width=1200,height=800')
              }
            >
              View in New Window
            </Button>
          </Box>
        </Box>
        <iframe
          src={this.state.invoiceData}
          height="600px"
          width="100%"
          style={{ border: 'none' }}
        />
      </div>
    )
  }

  public renderBillOut() {
    var match = new matchParams()
    match.params = new InvoiceParams()
    match.params.quoteId = this.state.associatedQuoteId

    return this.renderPdf()
  }

  public render() {
    return this.state.headerInfo ? (
      <WorkflowInbox
        inboxType={InboxItemType.Invoice}
        item={this.renderBillOut()}
        headerInfo={this.state.headerInfo}
        icon={<Receipt />}
      />
    ) : (
      <></>
    )
  }
}

const InjectedInvoiceInbox = inject<
  IStores,
  IInvoiceInboxProps,
  Partial<IInvoiceInboxProps>,
  any
>((stores: IStores) => ({
  rerouteToPath: stores.global.rerouteToPath,
  setReturn: stores.global.setReturn,
  closeTab: stores.global.closeTab,
  setUpdateParentAfterStaticAction: (parentFunction?: () => void) => {
    if (parentFunction) {
      stores.cms1500.setGetClaimValuesForStaticAction(() =>
        Promise.resolve({} as ICMS1500)
      )
    }
  },
}))(InvoiceInbox)

// Wrapper component to extract route params and pass them as props
const InvoiceInboxWrapper: React.FC = () => {
  const params = useParams<{ invoiceId?: string; inboxId?: string }>()
  return <InjectedInvoiceInbox invoiceId={params.invoiceId} inboxId={params.inboxId} />
}

export default InvoiceInboxWrapper
